import api from '../services/api';
import { ICovenant } from '../shared/interfaces';

interface IResponseGetCovenants {
  data: ICovenant[];
  count: number;
}
export const getCovenants = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetCovenants> => {
  const response = await api.post('/covenants/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postCovenant = async (payload: any): Promise<ICovenant> => {
  const response = await api.post(`/covenants`, payload);
  return response.data;
};

export const patchCovenant = async (
  id: string | undefined,
  payload: any,
): Promise<ICovenant> => {
  if (!id) {
    throw new Error('ID do convênio não fornecido.');
  }
  const response = await api.patch(`/covenants/${id}`, payload);
  return response.data;
};

export const getSelectCovenants = async (): Promise<ICovenant[]> => {
  const response = await api.get(`/covenants/select/all`);
  return response.data;
};
